/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Col_Document_KindInputs */

const en_inbound_col_document_kind = /** @type {(inputs: Inbound_Col_Document_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kind`)
};

/**
* | output |
* | --- |
* | "Kind" |
*
* @param {Inbound_Col_Document_KindInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_col_document_kind = /** @type {((inputs?: Inbound_Col_Document_KindInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Col_Document_KindInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_col_document_kind(inputs)
});